import { FormControl, FormControlLabel, FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { ICustomField, switchAnyValueToBool } from "@ryde/shared";

import { IsRead } from "../../controls/forms/switches/is-read";
import { ControlErrorDisplay } from "../parts-styled";

export const NotificationIsReadTemplate: FC<ICustomField> = ({
  id,
  name: fieldName,
  formLabel,
  formAttributes,
}) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { formLabelTranslated } = useDynamicFormsTranslate({
    name: fieldName,
    fallbackText: formLabel,
  });

  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        render={({ field: { value, ...rest }, fieldState: { error } }) => {
          return (
            <FormControl
              data-e2e-template="notification-is-read-template"
              data-e2e-field-name={fieldName}
              error={!!error}
            >
              <FormControlLabel
                {...rest}
                onChange={event => {
                  // IsRead component pass checked boolean value instead of event
                  const checked = event as unknown as boolean;
                  setValue(fieldName, checked, { shouldTouch: true });
                }}
                control={<IsRead dataE2EId={`${fieldName}_${id}`} />}
                label={formLabelTranslated}
                checked={switchAnyValueToBool(value)}
                disabled={formAttributes?.disabled}
                data-e2e-template="is-read-template"
              />
              {error && (
                <FormHelperText data-e2e="is-read-template-errors">
                  {error.message}
                </FormHelperText>
              )}
            </FormControl>
          );
        }}
      />
      <ControlErrorDisplay errors={errors} fieldName={fieldName} />
    </>
  );
};
